t = require('views/internal/teacup-with-helpers')('attachment_viewer_frame')

module.exports = ->
  t.div { class: 'attachment-viewer-frame js-close-viewer ' + t.mustacheVar('directionClass'), 'data-idAttachment': t.mustacheVar('id') }, ->

    t.div '.attachment-viewer-frame-preview-wrapper', ->
      t.div { class: 'attachment-viewer-frame-preview' + t.mustacheBlock('isImage', (-> ' attachment-viewer-frame-preview-image-wrapper')) }, ->

        t.mustacheBlock 'isImage', ->
          t.img '.attachment-viewer-frame-preview-image.js-stop', { src: t.mustacheVar('url'), alt: t.mustacheVar('name') }

        t.mustacheBlock 'isAudio', ->
          t.audio '.attachment-viewer-frame-preview-audio.js-stop', { controls: true, name: t.mustacheVar('name') }, ->
            t.source { src: t.mustacheVar('url'), type: 'audio/' + t.mustacheVar('ext') }

        t.mustacheBlock 'isVideo', ->
          t.video '.attachment-viewer-frame-preview-video.js-stop', { controls: true, name: t.mustacheVar('name'), src: t.mustacheVar('url') }

        t.mustacheBlock 'isIFrameable', ->
          t.iframe '.attachment-viewer-frame-preview-iframe.js-stop', { src: t.mustacheVar('url') }

        t.mustacheBlock 'isPlaceholder', ->
          t.p '.attachment-viewer-frame-preview-placeholder', ->
            t.format 'there-is-no-preview-available-for-this-attachment-opentext', { url: t.mustacheVar('url'), openText: t.mustacheVar('openText') }




// WEBPACK FOOTER //
// ./app/scripts/views/templates/attachment_viewer_frame.coffee